import React, { useRef, useEffect } from 'react';
import '../css/ClientSlider.css';

const ClientSlider  = ({ images, orientation = 'left' }) => {
    const trackRef = useRef(null);
    const positionRef = useRef(0);
    const isPausedRef = useRef(false);
    const direction = orientation === 'right' ? 1 : -1;
  
    // Duplicate images for seamless looping
    const displayedImages = [...images, ...images];
  
    useEffect(() => {
      const track = trackRef.current;
  
      // ✅ Initial position: if scrolling right, start from end of first half
      if (orientation === 'right' && track) {
        const trackHalfWidth = track.scrollWidth / 2;
        positionRef.current = -trackHalfWidth;
        track.style.transform = `translateX(${positionRef.current}px)`;
      }
  
      const scroll = () => {
        if (track && !isPausedRef.current) {
          positionRef.current += 0.5 * direction;
  
          const trackWidth = track.scrollWidth / 2;
  
          if (orientation === 'right' && positionRef.current >= 0) {
            positionRef.current = -trackWidth;
          } else if (orientation === 'left' && Math.abs(positionRef.current) >= trackWidth) {
            positionRef.current = 0;
          }
  
          track.style.transform = `translateX(${positionRef.current}px)`;
        }
  
        requestAnimationFrame(scroll);
      };
  
      requestAnimationFrame(scroll);
    }, [orientation, direction]);
  
    return (
      <div
        className="logo-slider-container"
        onMouseEnter={() => (isPausedRef.current = true)}
        onMouseLeave={() => (isPausedRef.current = false)}
      >
        <div className="logo-slider-track" ref={trackRef}>
          {displayedImages.map((src, index) => (
            <img key={index} src={src} alt={`Logo ${index}`} />
          ))}
        </div>
      </div>
    );
  };
  
  export default ClientSlider;